<div
  *ngIf="!fieldAttribute.hidden"
  [attr.data-test-id]="'wrap-' + fieldAttribute.elementDataTestId"
  [ngClass]="fieldAttribute.elementStyles.containerStyle"
  class="multiple-select-container"
>
  <label
    *ngIf="fieldAttribute.backendAttribute.label"
    [for]="fieldAttribute.id"
    class="form-label label"
    [ngClass]="fieldAttribute.elementStyles.labelStyle"
    (click)="$event.preventDefault()"
  >
    {{ fieldAttribute.backendAttribute.label | translate }}
    <span *ngIf="fieldAttribute.backendAttribute.required">*</span>
    <div
      *ngIf="isMobileView && isShowInfoTooltip && !tooltipDescription"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip"
      placement="bottom auto"
      triggers="click:blur"
      [ngbTooltip]="fieldAttribute.backendAttribute.placeholder | translate"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
    <div
      *ngIf="isShowInfoTooltip && tooltipDescription"
      class="ms-1 custom-tooltip"
      data-test-id="info-tooltip-disease"
      placement="bottom auto"
      triggers="click:blur"
      [ngbTooltip]="tipContent"
    >
      <img src="assets/icons/icon-info.svg" alt="info" />
    </div>
  </label>
  <div
    [class.is-invalid]="isFieldInvalid()"
    [class.pe-5]="isFieldInvalid()"
    [class.disabled-control]="isControlDisabled()"
    [ngClass]="fieldAttribute.elementStyles.contentStyle"
    [class.fixed-height]="fieldAttribute.backendAttribute.scheme_name !== SearchFormTypes.MAP_SEARCH_BLOCK"
    [attr.data-test-id]="'container_' + fieldAttribute.elementDataTestId"
    class="d-flex flex-row flex-wrap"
  >
    <span class="btn btn-outline-secondary btn-sm selected" *ngFor="let item of selectedItems; index as i">
      {{ item.title | translate }}
      <span
        [attr.data-test-id]="fieldAttribute.elementDataTestId + '-item-' + i"
        class="close-selected"
        (click)="onCloseItem(item)"
      >
        <b>x</b>
      </span>
    </span>
    <input
      appToggleOverflow
      class="multiple-search-input"
      [class.disabled-control]="isControlDisabled()"
      [class.mt-1]="selectedItems.length > 0"
      type="text"
      #multipleSearchInput
      #typehead="ngbTypeahead"
      multiple
      container="body"
      [attr.data-test-id]="fieldAttribute.elementDataTestId"
      [id]="fieldAttribute.id"
      [placeholder]="(isMobileView ? newPlaceholder : fieldAttribute.backendAttribute.placeholder) | translate"
      [ngbTypeahead]="search"
      [inputFormatter]="formatter"
      [resultFormatter]="formatter"
      (selectItem)="onSelectItem($event)"
      (focus)="focus$.next($event.target.value)"
      (click)="click$.next($event.target.value)"
      (blur)="checkErrors()"
    />
  </div>
  <ng-container *ngIf="typehead && typehead.isPopupOpen()">
    <dropdown-list-pagination
      [paginationState]="paginationState$ | async"
      [isLoading]="isLoading$ | async"
      [dropdownSelector]="dropdownSelector"
      (loadMore)="onLoadMore($event)"
    ></dropdown-list-pagination>
  </ng-container>
  <small
    *ngIf="form.get(fieldAttribute.backendAttribute.name) && form.get(fieldAttribute.backendAttribute.name).invalid"
    class="d-flex mt-1 invalid-feedback"
    [attr.data-test-id]="fieldAttribute.errorDataTestId"
  >
    {{ getValidationError(form.get(fieldAttribute.backendAttribute.name)) | translate }}
  </small>
</div>

<ng-template #tipContent
  >{{ tooltipDescription }}
  <a class="contact-us text-primary" data-test-id="login-form-forgot-password" [routerLink]="'/contact-us'">
    {{ 'FOOTER_NAVIGATION_CONTACT_US' | translate }} </a
  >.</ng-template
>
